import retailerReducer from './slices/retailerSlice';
import taxonomyReducer from './slices/taxonomySlice';
import userReducer from './slices/userSlice';
import cart from '@agrantis/cart/reducers/cart';
import { configureStore } from '@reduxjs/toolkit';

const loadCartState = () => {
  try {
    const serializedState = localStorage.getItem('cartState');
    if (!serializedState) return undefined;
    return JSON.parse(serializedState);
  } catch (err) {
    console.error('Load cart state error:', err);
    return undefined;
  }
};

const cartPersistMiddleware = (store) => (next) => (action) => {
  const result = next(action);

  const cartActions = [
    'ADD_CART_ITEM',
    'REMOVE_CART_ITEM',
    'UPDATE_CART_ITEM',
    'MOVE_CART_ITEM',
    'UPDATE_CART_DELIVERY',
    'SET_CART',
    'CLEAR_CART',
    'CLEAR_CART_STORE',
  ];

  if (typeof window !== 'undefined' && cartActions.includes(action.type)) {
    const state = store.getState();
    try {
      localStorage.setItem('cartState', JSON.stringify(state.cart));
    } catch (err) {
      console.error('Save cart state error:', err);
    }
  }

  return result;
};

const store = configureStore({
  reducer: {
    user: userReducer,
    retailer: retailerReducer,
    taxonomy: taxonomyReducer,
    cart: cart,
  },
  preloadedState: {
    cart: loadCartState(),
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(cartPersistMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
